import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BtnDeleteCellRenderer } from 'src/app/btn-deletecell-renderer';
import { EditBtnRenderer } from 'src/app/edit-action-btn-renderer.component';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { ErpService } from 'src/app/services/erp.service';
import { ProductivityService } from 'src/app/services/productivity-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Multilingual } from 'src/app/services/multilingual';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-erp-plant-mapping',
  templateUrl: './erp-plant-mapping.component.html',
  styleUrls: ['./erp-plant-mapping.component.scss'],
})
export class ErpPlantMappingComponent implements OnInit {
  @ViewChild('plantMappingPopup')
  private plantMappingPopup!: TemplateRef<any>;
  breadcrumList: any;
  moduleId: any;
  pageId: any;
  permisson: any;
  IsAccess: any;
  IsWrite: any;
  filteredGroups: any;
  GroupList: any;
  plantMappingHeaderForm: FormGroup;
  plantMappingForm: FormGroup;
  value: string;
  deparmentList: any;
  deparmentFiltList: any;
  PlantList: any;
  filteredPlants: any;
  frameworkComponents = {
    EditBtnRenderer: EditBtnRenderer,
    BtnDeleteCellRenderer: BtnDeleteCellRenderer,
  };
  rowData: any = [];
  columnDefs: any = [
    {
      headerName: 'Edit',
      field: 'Edit',
      cellRenderer: 'EditBtnRenderer',
      maxWidth: 90,
      cellRendererParams: {
        onClick: this.onEdit.bind(this),
      },
      headerValueGetter: this.localizeHeader.bind(this)
    },
    {
      headerName: 'Delete',
      field: 'Delete',
      cellRenderer: 'BtnDeleteCellRenderer',
      maxWidth: 90,
      cellRendererParams: {
        onClick: this.onDelete.bind(this),
      },
      headerValueGetter: this.localizeHeader.bind(this)
    },
    { headerName: 'Plant Description', field: 'PlantDescription', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Company', field: 'Company', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Created On  ', field: 'CreatedOn', headerValueGetter: this.localizeHeader.bind(this) },
    {
      headerName: 'Created By',
      field: 'CreatedBy',
      valueFormatter: function (params: any) {
        return params.value !== null
          ? moment(params.value).format('MM/DD/YYYY')
          : '';
      },
      headerValueGetter: this.localizeHeader.bind(this)
    },
  ];
  gridApi: any;
  gridColumnApi: any;
  gridOptions: any = {
    defaultColDef: {
      rowHeight: 45,
      rowStyle: {
        'border-bottom': 'white 10px solid',
        'border-top': 'white 10px solid',
        'max-height': '50px',
      },
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    // headerHeight: 150,
    popupParent: document.querySelector('body'),
    // floatingFilter: true,
  };
  rawMaterialItemForm: FormGroup;
  slectedRMTypeID: number;

  editType: boolean = false;
  eidtItem: boolean = false;
  selectedRMItemID: any;
  formDirective: any;
  file: any = [];
  excelFileRaw: any = [];
  exportData: any;
  readyToUpload: boolean = false;
  excelFile: any = [];
  languageDir: string;
  langObj: any = {};
  lang: any;
  constructor(
    private toaster: ToastrService,
    public router: Router,
    private userService: UserManagementService,
    private enterpriseGroupService: EnterPriseGroupService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private productivityservice: ProductivityService,
    private fb: FormBuilder,
    private ErpService: ErpService,
    public translate: TranslateService,
    public translater: TranslaterService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();});
  }

  ngOnInit(): void {
    this.plantMappingHeaderForm = this.fb.group({
      group: ['', Validators.required],
      plant: ['', Validators.required],
    });

    this.plantMappingForm = this.fb.group({
      company: ['', Validators.required],
    });

    this.getGroup();
    this.GetBreadcrumList();
    this.GetMenuAccess();
  }
  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    this.userService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId =
          this.breadcrumList && this.breadcrumList.length
            ? this.breadcrumList[0].id
            : '';
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        this.getLangWords();
        this.lang = new Multilingual(this.translater,this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error?.Status);
      }
    );
  }
  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value:string){
    let val;
    if(this.langObj && this.langObj[value]){
      val = this.langObj[value];
    }
    return val?val:value;
 }
  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if(this.langObj){
        this.gridApi.refreshHeader();
      }
    });
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.enterpriseGroupService.GetMenuAccess(key).subscribe(
      (data: any) => {
        this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }
  getGroup(): void {
    const key = {
      UserId: JSON.parse(localStorage.user).UserId,
    };
    const id = {
      value: 0,
    };
    this.productivityservice.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.lstEG;
        if (this.GroupList && this.GroupList.length) {
          this.plantMappingHeaderForm.controls.group.patchValue(
            this.GroupList[0].EG_Id
          );
        }
        this.filteredGroups = this.GroupList.slice();
        this.getPlants();
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }
  getPlants() {
    const key = {
      EG_ID: this.plantMappingHeaderForm.value.group,
      userId: JSON.parse(localStorage.user).UserId,
    };

    this.productivityservice.getPlantsData(key).subscribe(
      (data: any) => {
        this.PlantList = data.lstPlant;
        this.plantMappingHeaderForm.controls.plant.patchValue(
          this.PlantList[0].PT_Id
        );
        this.filteredPlants = this.PlantList.slice();
        this.filterData();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  /// AG Grid
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  excelExport() {
    this.gridApi.exportDataAsExcel();
  }

  csvExport() {
    this.gridApi.exportDataAsCsv();
  }

  saveFormData(formDirective) {
    if (this.plantMappingHeaderForm.valid) {
      this.formDirective = formDirective;
      const data = {
        ID: this.editType ? this.slectedRMTypeID : 0,
        TransTypeID: this.editType ? 2 : 1,
        Company: this.plantMappingForm.value.company,
        PlantID: this.plantMappingHeaderForm.value.plant,
        CreatedOn: new Date(),
        CreatedBy: JSON.parse(localStorage.user).UserId,
      };

      this.ErpService.getPlantMappingIUCD(data).subscribe(
        (res: any) => {
          if (res.HasError) {
            this.toaster.error(res?.Status, 'Error');
          } else {
            if (res?.Status == 'Already Exists') {
              this.toaster.warning(res?.Status, 'Warning');
            } else {
              this.toaster.success(res?.Status, 'Success');

              this.filterData();
              this.editType = false;
              this.formDirective.resetForm();
              this.plantMappingForm.reset();
              this.dialog.closeAll();
            }
          }
        },
        (err: any) => {
          this.toaster.error(err, 'Error');
        }
      );
    } else {
      this.toaster.warning('All the fields are Mandatory', 'Warning');
    }
  }
  filterData() {
    const data = {
      ID: 0,
      TransTypeID: 4,
      Company: this.plantMappingForm.value.company,
      PlantID: this.plantMappingHeaderForm.value.plant,
      CreatedOn: new Date(),
      CreatedBy: JSON.parse(localStorage.user).UserId,
    };

    this.ErpService.getPlantMappingIUCD(data).subscribe(
      (res: any) => {
        if (res?.DTRes && res.DTRes.length) {
          this.rowData = res.DTRes;

          this.rowData.map((res: any) => {
            res.IsWrite = this.IsWrite;
          });
        } else this.rowData = [];
        if (res?.HasError) this.toaster.error(res?.Status, 'Error');
      },

      (err: any) => {
        this.toaster.error(err, 'Error');
      }
    );
  }
  onEdit(param: any) {
    this.editType = true;
    this.plantMappingForm.controls.company.patchValue(param.rowData.Company);
    this.slectedRMTypeID = param.rowData.Id;
    this.openPopup();
  }
  onDelete(params: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to Reject This Raw Material!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        const data = {
          ID: params.rowData.Id,
          TransTypeID: 3,
          Company: this.plantMappingForm.value.company,
          PlantID: this.plantMappingHeaderForm.value.plant,
          CreatedOn: new Date(),
          CreatedBy: JSON.parse(localStorage.user).UserId,
        };
        this.ErpService.getPlantMappingIUCD(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            if (res?.HasError) {
              this.toaster.error(res?.Status, 'Error');
            } else {
              this.toaster.success(res?.Status, 'Success');
              this.editType = false;
              this.slectedRMTypeID = 0;
              this.plantMappingForm.reset();
              this.dialog.closeAll();

              this.filterData();
            }
          },

          (err: any) => {
            this.toaster.error(err, 'Error');
          }
        );
      }
    });
  }
  openPopup() {
    let dialogRef = this.dialog.open(this.plantMappingPopup, {
      width: '40%',
      height: '40%',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.slectedRMTypeID = 0;
      this.eidtItem = false;
      this.selectedRMItemID = 0;
      this.formDirective?.resetForm();
      this.rawMaterialItemForm.reset();
    });
  }
}
